import { SyntheticEvent } from 'react';

import { ItemLabelModel } from '../../../shared/components/dropdown/models/dropdown-props.model';
import { GetStringKeys } from '../../../shared/types/get-string-keys.type';

export const setInputValue = <TFormikValuesModel>(
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
  name: GetStringKeys<TFormikValuesModel>,
  setFieldTouched?: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void
) => {
  return function (
    event: SyntheticEvent,
    value:
      | string
      | ItemLabelModel<number>
      | (string | ItemLabelModel<number>)[]
      | null
  ) {
    setFieldTouched?.(name, true, false);
    setFieldValue(name, value);
  };
};
